(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    

  $('#treadmills .scroll_button.left').click(function() {
	$('#treadmills .product').animate({
	  scrollLeft: $('#treadmills .product').scrollLeft() - $('.product').width()
	},1000);
  });
  $('#treadmills .scroll_button.right').click(function() {
	$('#treadmills .product').animate({
	  scrollLeft: $('#treadmills .product').scrollLeft() + $('.product').width()
	},1000);
  });

  $('#ellipticals .scroll_button.left').click(function() {
	$('#ellipticals .product').animate({
	  scrollLeft: $('#ellipticals .product').scrollLeft() - $('.product').width()
	},1000);
  });
  $('#ellipticals .scroll_button.right').click(function() {
	$('#ellipticals .product').animate({
	  scrollLeft: $('#ellipticals .product').scrollLeft() + $('.product').width()
	},1000);
  });

  $('#bikes .scroll_button.left').click(function() {
	$('#bikes .product').animate({
	  scrollLeft: $('#bikes .product').scrollLeft() - $('.product').width()
	},1000);
  });
  $('#bikes .scroll_button.right').click(function() {
	$('#bikes .product').animate({
	  scrollLeft: $('#bikes .product').scrollLeft() + $('.product').width()
	},1000);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-browse_consoles"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function(){
    $(".desc .console-desc:first-of-type").addClass('show');
    $(".console figure:first-of-type").addClass('highlight');
  });

  /*$('.home-page-browse_consoles .scroll_button.left').click(function() {
	$('#treadmills .console').animate({
	  scrollLeft: $('#treadmills .console').scrollLeft() - $('.console figure').width()
	},5000);
  });
  $('.home-page-browse_consoles .scroll_button.right').click(function() {
	$('#treadmills .product').animate({
	  scrollLeft: $('#treadmills .product').scrollLeft() + $('.product figure').width()
	},5000);
  });*/


  } catch(e) { console.error(e); }
})();

})();
